"use client"

import type { CategoryConfig } from "../../../tamda-media/TamdaMediaNewsLayout/types/config"

interface CategorySidebarProps {
  title: string
  categories: CategoryConfig[]
  selectedCategoryId?: string
  onCategoryClick: (categoryId: string) => void
  className?: string
}

export function CategorySidebar({
  title,
  categories,
  selectedCategoryId,
  onCategoryClick,
  className = "",
}: CategorySidebarProps) {
  const safeCategories = Array.isArray(categories) ? categories : []

  const handleClick = (e: React.MouseEvent, categoryId: string) => {
    e.preventDefault()
    e.stopPropagation()
    onCategoryClick(categoryId)
  }

  return (
    <aside className={`w-full sm:w-[17.1%] flex flex-col sm:gap-[15px] sm:mt-4 gap-[26px] mt-[30px] ${className}`}>
      <h2 className="sm:text-2xl sm:leading-[26px] text-xl leading-[24px] font-bold text-[#333]">
        {title}
      </h2>

      <nav className="flex sm:flex-col flex-row sm:gap-4 gap-2.5 sm:items-start">
        {safeCategories.map((item, index) => {
          const categoryId = String(item.category?.categoryId ?? index)
          const isActive = categoryId === selectedCategoryId
          return (
            <button
              type="button"
              key={categoryId}
              onClick={(e) => handleClick(e, categoryId)}
              className={`w-full sm:text-base sm:leading-[24px] text-[14px] leading-[16px] uppercase text-start p-3 sm:p-0 sm:rounded-none rounded ${isActive
                ? "font-medium sm:font-bold sm:text-[#18af4e] text-white sm:bg-transparent bg-[#18af4e]"
                : "font-medium sm:font-normal sm:text-[#333] text-[#18af4e] sm:bg-transparent bg-[#f7f7f7]"
                }`}
            >
              {item.category?.categoryName || "Category"}
            </button>
          )
        })}
      </nav>
    </aside>
  )
}
